<template>
    <div class="row selectlocation">
        <div class="container">
            <div class="row">
                <div class="col-md">
                    <h4>Store location</h4>
                </div>
                <div class="col-md pt-1">
                    #{{ location.store_number }} {{ location.name }} ({{ location.city }}, {{ location.state }} {{ location.zipcode }})
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  props: ["location"],
}
</script>
